import { InputAdornment, Stack, TextField, Typography } from '@mui/material';
import Iconify from 'src/components/Iconify';
import {
  engagementListSearchConfig,
  isReservedSearchTerm,
  ListSearchConfig,
} from 'src/sections/engagement/config/engagementListSearchConfig';

type Props = {
  search: string;
  onSearch: (value: string) => void;
  config?: ListSearchConfig;
};

// Search-only toolbar for engagement list. Filters live in the filter drawer (consistent with Case/Patient lists).

export default function EngagementListToolbar({
  search,
  onSearch,
  config = engagementListSearchConfig,
}: Props) {
  const showReservedHint = search.trim() !== '' && isReservedSearchTerm(search, config);

  return (
    <Stack sx={{ minWidth: 240, flex: '1 1 200px' }}>
      <TextField
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder={config.searchableHint}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify
                icon="eva:search-fill"
                sx={{ color: 'text.disabled', width: 20, height: 20 }}
              />
            </InputAdornment>
          ),
        }}
      />
      {showReservedHint && (
        <Typography variant="caption" sx={{ color: 'warning.main', mt: 0.5 }} role="alert">
          &quot;{search.trim()}&quot; is not a searchable term. Try: name, MRN, or engagement
          number.
        </Typography>
      )}
    </Stack>
  );
}
